import { useTranslation } from "react-i18next"
import Button from "../../components/global/Button"
import Center from "../../components/global/Center"
import Text from "../../components/global/Text"
import { useContext } from "react"
import { AuthContext } from "../../controllers/auth"
import { Stack } from "@mui/material"
import { copyTextToClipboard } from "../../services/utils/utils"

const Error = () => {
  const { t } = useTranslation()
  const { error, logOut } = useContext(AuthContext)

  return (
    <Center>
      <Text textAlign="center">{t("error_title")}</Text>
      <Stack gap={1} direction="row">
        <Button
          primary
          onClick={() => copyTextToClipboard(JSON.stringify(error))}
          style={{ width: 100, marginTop: 24 }}
        >
          {t("copy_error")}
        </Button>
        <Button
          onClick={() => window.location.reload()}
          style={{ width: 100, marginTop: 24 }}
        >
          {t("retry")}
        </Button>
        <Button onClick={logOut} style={{ width: 100, marginTop: 24 }}>
          {t("logout")}
        </Button>
      </Stack>
    </Center>
  )
}

export default Error
